<template>
  <section class="mo-pageheader flex flex-space">
    <div class="title">
      <slot name="title"></slot>
    </div>
    <div class="action">
      <slot name="action"></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MoPageheader',
};
</script>

<style scoped>
.mo-pageheader {
  height: 47px;
  border-bottom: 1px solid rgb(200, 200, 200);
}
.mo-pageheader .title {
  font-size : 18px;
  font-weight: 500;
}
.mo-pageheader .title .label {
  color: var(--app-secondary-color);
}
</style>
